module.exports = __webpack_public_path__ + "static/media/main3.2a63e058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main3.jpg
// module id = 83
// module chunks = 0